import {useQuery} from 'react-query';
import {getWholesalerSaleTypes} from 'services/wholesaler/advertisement/add/saleTypes';
const useGetSaleType = () => {
  const {data, isLoading} = useQuery(
    ['wholesaler-sale-type'],
    getWholesalerSaleTypes,
  );
  return {WholesalerTypeSales: data, isLoading};
};

export default useGetSaleType;
